module.exports = __webpack_public_path__ + "media/images/marketing/joy_cover-aabee5f2e8b574a45ebd9a86f28bbce97378258bb50481a56a1f7da1c2d3d443.jpg";